import { useRef, useState } from "react";
import { Button, Drawer, HeadingRow, Heading, Treegrid } from "cai-fusion";

import { ReactComponent as IconCloseSquare } from "../../../../../images/close-square.svg";

import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";
import { useSiftV2 } from "../../../contexts/siftV2Context";

const ShareOpportunityDrawer = () => {
    const searchTimeoutRef = useRef();
    const [users, setUsers] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    //sharedUsers = chatMembers same concept
    
    const { hide, visibilityStates } = useTransientVisibility();
    const { currOpp, placeholderSuggestedUsers } = useSiftV2();

    const handleInputChange = (e) => {
        const currentValue = e.target.value;
        setSearchValue(e.target.value);
        if (e.target.value === "" || e.target.value === undefined) {
            setUsers([]);
        } else {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }

            // Set a new timeout
            searchTimeoutRef.current = setTimeout(() => {
                // Use currentValue directly
                // searchUsers(currentValue).then((resp) => setUsers(resp));
            }, 200);
        }
    }

    return (
        <Drawer
            clickOutsideToClose
            isHidden={!visibilityStates.ShareOpportunityDrawer}
            id="sharing-drawer"
            onClose={() => hide('ShareOpportunityDrawer')}
            header={
                <HeadingRow
                    title="Opportunity Sharing"
                    eyebrow="Settings"
                    size={3}
                >
                    <div className="m-icon-row m-icon-row--right-align">
                        <a
                            id="drawerCloseBtn"
                            className="a-icon m-icon-row__icon"
                            title="Close Associate Details"
                            onClick={(e) => {
                                e.preventDefault();
                                hide('ShareOpportunityDrawer')
                            }}
                        >
                            <IconCloseSquare className="a-icon__img" />
                        </a>
                    </div>
                </HeadingRow>
            }
        >
            <form className="o-form l-mt-sm">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row l-mb-xs">
                            <div className="col-12">
                                <Heading size={3}>People with Access to this Opportunity</Heading>
                                <p className="a-muted-text">The following people have been added to this opportunity. Opportunity managers may update the details of the opportunity, as well as add/remove documents. Contributors may add comments.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="o-block">
                                    <Treegrid id="sharedUsers" isCompact className="l-mr-sm" columnSizes={["small", "small", "small"]}>
                                        {/* Existing data store members */}
                                        {currOpp?.users?.map((member) => {
                                            return (
                                                <tr className="o-treegrid__row o-treegrid__row--shown" key={member}>
                                                    <td className="o-treegrid__cell">
                                                        <span className="a-subtle-text">
                                                            <strong>{member}</strong>
                                                        </span>
                                                    </td>
                                                    <td className="o-treegrid__cell o-treegrid__cell--right-aligned">
                                                        <label className="visually-hidden" htmlFor="permissions-1">Permissions</label>
                                                        <select id="permissions-1" className="a-select-input" value="3" >
                                                            {/* {Object.keys(membershipLevels).map((level) =>  */}
                                                                <option value="3" key="3">View Only</option>
                                                                <option value="2" key="2">Contribute</option>
                                                                <option value="1" key="1">Manage</option>
                                                            {/* )} */}
                                                            { false && <option value="0">Owner</option>}
                                                        </select>
                                                    </td>
                                                    <td className="o-treegrid__cell">
                                                        {true && <Button outline size="small" fullWidth children="Remove" />}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        {/* Add opportunity members box */}
                                        { true &&
                                            <tr className="o-treegrid__row o-treegrid__row--no-border o-treegrid__row--shown">
                                                <td className="o-treegrid__cell o-treegrid__cell" colSpan="3">
                                                    <div className="m-autocomplete-input">
                                                        <label className="visually-hidden" htmlFor="autocompleteInput"></label>
                                                        <input id="autocompleteInput" type="text" value={searchValue} placeholder="Add another person..." className="a-text-input l-mt-xs" onChange={(e) => handleInputChange(e)} />
                                                        <div className="m-autocomplete-input__dropdown m-autocomplete-input__dropdown--shown" id="autocompleteDropdown">
                                                            {/* {searchValue !== "" && users?.map(user => {
                                                                return (
                                                                    <button className="m-autocomplete-input__dropdown-item" type="button" key={compileNameHelper(user)} onClick={(e) => { e.preventDefault(); setSearchValue(""); setUsers([]); shareDataStore(user); }}>
                                                                        <div className="m-autocomplete-input__dropdown-item-title">{user?.givenName ?? user?.identifier} {(user?.familyName ?? "")}</div>
                                                                        <div className="m-autocomplete-input__dropdown-item-meta">{user.jobTitle ?? user?.identifier}</div>
                                                                    </button>
                                                                )
                                                            })} */}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                    </Treegrid>
                                </div>
                            </div>
                        </div>
                        {/* Suggested Users to add - please do not remove */}
                        {/* <div className="row l-mb-xs l-mt-md">
                            <div className="col-12">
                                <Heading size={3}>Suggested Contributors</Heading>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="o-block">
                                    <Treegrid isCompact className="l-mr-sm" columnSizes={["small", "medium", "x-small"]}>
                                        {placeholderSuggestedUsers.map((user) => (
                                            <tr className="o-treegrid__row o-treegrid__row--shown">
                                                <td className="o-treegrid__cell">
                                                    <span className="a-subtle-text"><strong>{user.name}</strong></span>
                                                </td>
                                                <td className="o-treegrid__cell">
                                                    <span className="a-muted-text">{user.role}</span>
                                                </td>
                                                <td className="o-treegrid__cell">
                                                    <Button outline size="small" fullWidth>
                                                        Add
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </Treegrid>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </form>
        </Drawer>
    )
}; export default ShareOpportunityDrawer;